import { createRouter, createWebHistory } from "vue-router";

/** 路由级按需加载：进入对应路由时才下载该 chunk */
const routes = [
  {
    path: "/",
    name: "home",
    component: () =>
      import(/* webpackChunkName: "layout-home" */ "../views/HomeView.vue"),
    children: [
      {
        path: "/",
        name: "HomeContainer",
        component: () =>
          import(/* webpackChunkName: "home" */ "../components/HomeContainer.vue"),
      },
      {
        path: "/os",
        name: "OperatingSystem",
        component: () =>
          import(
            /* webpackChunkName: "os-harmony" */ "../components/OperatingSystem.vue"
          ),
      },
      {
        path: "/androidOperatingSystemCustomization",
        name: "androidOperatingSystemCustomization",
        component: () =>
          import(
            /* webpackChunkName: "os-android" */ "../components/androidOperatingSystemCustomization.vue"
          ),
      },
      {
        path: "/smartWater",
        name: "smartWater",
        component: () =>
          import(/* webpackChunkName: "smart-water" */ "../components/smartWater.vue"),
      },
      {
        path: "/softwareCustomization",
        name: "softwareCustomization",
        component: () =>
          import(
            /* webpackChunkName: "software" */ "../components/softwareCustomization.vue"
          ),
      },
      {
        path: "/humanResourcesServices",
        name: "humanResourcesServices",
        component: () =>
          import(
            /* webpackChunkName: "hr" */ "../components/humanResourcesServices.vue"
          ),
      },
      {
        path: "/smartFirefighting",
        name: "smartFirefighting",
        component: () =>
          import(
            /* webpackChunkName: "fire" */ "../components/smartFirefighting.vue"
          ),
      },
      {
        path: "/corporate",
        name: "corporate",
        component: () =>
          import(/* webpackChunkName: "corporate" */ "../components/corporate.vue"),
      },
      {
        path: "/contentPlatform",
        name: "contentPlatform",
        component: () =>
          import(
            /* webpackChunkName: "content-platform" */ "../components/contentPlatform.vue"
          ),
      },
      {
        path: "/smallGamePlatform",
        name: "smallGamePlatform",
        component: () =>
          import(
            /* webpackChunkName: "small-game" */ "../components/smallGamePlatform.vue"
          ),
      },
      {
        path: "/contactUs",
        name: "contactUs",
        component: () =>
          import(
            /* webpackChunkName: "small-game" */ "../components/contactUs.vue"
          ),
      },
      {
        path: "/aboutUsEn",
        name: "aboutUsEn",
        component: () =>
          import(
            /* webpackChunkName: "small-game" */ "../components/aboutUsEn.vue"
          ),
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    // 每次切换路由都回到顶部（包含后退/前进）
    return { left: 0, top: 0 };
  },
});

export default router;
